import { HardDrive } from 'lucide-react';
import SiteFooter from './SiteFooter.jsx';

export default function LegalLayout({ title, meta, children }) {
  return (
    <div className="ed-page min-h-screen flex flex-col">
      <header className="max-w-6xl mx-auto px-6 py-6 flex justify-between items-center gap-4 w-full">
        <a href="/" className="flex items-center gap-3 hover:opacity-70 transition-opacity">
          <HardDrive className="w-7 h-7" />
          <span className="leading-tight">
            <span className="block text-xl font-extrabold tracking-tight">Tresor</span>
            <span className="ed-eyebrow ed-eyebrow-brand">Cloudspeicher für Endkunden · Datenputzer</span>
          </span>
        </a>
        <a href="/" className="ed-link text-sm">Zur Startseite</a>
      </header>

      <main className="flex-1 max-w-3xl mx-auto px-6 py-12 md:py-16 w-full legal-main">
        <p className="ed-eyebrow mb-4">Rechtliches</p>
        <h1 className="ed-display text-4xl md:text-5xl mb-3">{title}</h1>
        {meta && <p className="ed-muted text-sm mb-10">{meta}</p>}
        <hr className="ed-rule-strong mb-10" />
        <div className="legal-content">{children}</div>
      </main>

      <SiteFooter />
    </div>
  );
}
